<template>
    <div :class="{'inline-top': !showTitle}">
        <div class="post-top-content-title" :class="{'post-desc-item': !showTitle}">
            <i class="fa fa-check mimic-title answered" v-if="topic.answered && displayMode === 'small' && !isHelpdesk">
                <span>{{ translations['forum.question_answered'] }}</span>
            </i>
            <div class="post-title">
                <i v-if="topic.sticky" class="fa fa-thumbtack secondary-c"></i>
                <i v-if="!topic.permissions.includes('READ')" class="far fa-lock"></i>
                <template v-if="topic.challenge">
                    <a v-if="topic.permissions.includes('VIEW_CHALLENGE') && topic.permissions.includes('READ')" :href="'/conversations/' + topic.slug">
                        <i class="fa fa-trophy post-challenge-icon mimic-title">
                            <span>
                                {{ topic.challenge.name }}
                            </span>
                        </i>
                    </a>
                    <a v-else href="#">
                        <i class="fal fa-trophy post-challenge-icon mimic-title">
                            <span>
                                {{topic.challenge.name }}
                            </span>
                        </i>
                    </a>
                </template>
                <template v-if="showTitle">
                    <a class="post-name hover-opacity" v-if="topic.permissions.includes('READ')" :href="!isHelpdesk ? '/conversations/' + topic.slug : '#'" v-html="topic.title"></a>
                    <a class="post-name hover-opacity" @click="checkAvailability(topic)" v-else href="#" v-html="topic.title"></a>
                </template>
                <template v-if="displayBoard">
                    <template v-if="channel && viewType !== 'moodview'">
                        <a :href="'/boards/' + channel.slug" class="post-related-board-wrapper" v-if="channel">
                        <span class="post-related-board-name hover-opacity" :style="{ background: channel.color }">
                            {{ channel.name }}
                        </span>
                        </a>
                    </template>
                </template>
            </div>
            <template v-if="showTopicActions">
                <i :class="{'animate-toggle' : media_visible}" v-if="user" class="fa fa-ellipsis-v post-media-mobile-toggle extra-light-text float-right hover-opacity no-select" @click="openMediaDropdown"></i>
                <div class="post-media no-select" v-if="user" v-show="media_visible" v-click-outside="closeMediaDropdown">

                    <slot name="action-slot"></slot>

                    <div class="media-item-wrapper inline-block hover" @click="openPopup('edit_topic', topic); closeMediaDropdown();" v-if="!topic.closed && (topic.permissions.includes('EDIT') || topic.permissions.includes('EDIT_CHANNEL')) && topic.post_type !== 'birthday'">
                        <i class="fal fa-edit secondary-c-hover extra-light-text mimic-title"></i>
                        <span class="inline-block">{{ translations['fields.edit'] }}</span>
                    </div>
                    <div class="media-item-wrapper inline-block hover" @click="openPopup('delete_feed_item', {item: topic, type: 'topic'}); closeMediaDropdown();" v-if="topic.permissions.includes('DELETE')">
                        <i class="fal fa-trash secondary-c-hover extra-light-text mimic-title"></i>
                        <span class="inline-block">{{ translations['fields.delete'] }}</span>
                    </div>
                    <div class="media-item-wrapper inline-block hover" @click="lockTopic({topic: topic, status: topic.closed}); closeMediaDropdown();" :class="{'active-media-item bold-text' : topic.closed}" v-if="viewType !== 'moodview' && topic.permissions.includes('CLOSE')">
                        <i class="fal fa-lock secondary-c-hover extra-light-text mimic-title" :class="{'fa fa-unlock bold-text' : topic.closed}"></i>
                        <span class="inline-block" v-if="topic.closed">Open topic</span>
                        <span class="inline-block" v-else>
                        {{ translations['forum.close_topic'] }}
                    </span>
                    </div>
                    <div class="media-item-wrapper inline-block hover"
                         @click="stickyTopic({topic: topic, comment_id: topic.post_id, sticky: topic.sticky}); closeMediaDropdown();"
                         :class="{'active-media-item bold-text' : topic.sticky}"
                         v-if="viewType !== 'moodview' && topic.permissions.includes('MAKE_STICKY')">
                        <i class="fal fa-thumbtack secondary-c-hover extra-light-text mimic-title" :class="{'fa bold-text' : topic.sticky}"></i>
                        <span class="inline-block" v-if="!topic.sticky">Sticky</span>
                        <span class="inline-block" v-else>{{ translations['forum.remove_sticky'] }}</span>
                    </div>
                    <div class="media-item-wrapper inline-block hover"
                         @click="setNotifications({topic: topic, notifications: topic.notifications}); closeMediaDropdown();"
                         :class="{'active-media-item bold-text' : topic.notifications}"
                         v-if="viewType !== 'moodview' && user">
                        <i class="fal fa-envelope secondary-c-hover extra-light-text mimic-title" :class="{'fa bold-text' : topic.notifications}"></i>
                        <span class="inline-block" v-if="!topic.notifications">{{ translations['forum.email_notifications_on'] }}</span>
                        <span class="inline-block" v-else>{{ translations['forum.email_notifications_off'] }}</span>
                    </div>
                    <div class="media-item-wrapper inline-block hover"
                         @click="favoriteTopic({topic: topic, favorite: topic.favorited}); closeMediaDropdown();"
                         :class="{'active-media-item bold-text' : topic.favorited}"
                         v-if="viewType !== 'moodview' && user">
                        <i class="fal fa-star secondary-c-hover extra-light-text mimic-title" :class="{'fa bold-text' : topic.favorited}"></i>
                        <span class="inline-block" v-if="!topic.favorited">
                        {{ translations['forum.favorite'] }}
                    </span>
                        <span class="inline-block" v-else>
                        {{ translations['forum.favorite_remove'] }}
                    </span>
                    </div>
                    <div class="media-item-wrapper inline-block hover"
                         @click="markTopicAsUnread(topic); closeMediaDropdown();"
                         :class="{'active-media-item bold-text' : topic.unread}"
                         v-if="singleTopic && user.isAdmin || singleTopic && user.isModerator">
                        <i class="fal fa-eye-slash secondary-c-hover extra-light-text mimic-title" :class="{'fa bold-text' : topic.unread}"></i>
                        <span class="inline-block">
                        {{ translations['forum.mark_as_unread'] }}
                    </span>
                    </div>
                </div>
            </template>
        </div>
        <div class="post-top-content-name" v-if="showUserCredentials">
            <template v-if="displayMode !== 'small' || isHelpdesk">
                <i v-if="topic.user().streak >= settings.onfire_count && plugins.gamification" class="far fa-fire onfire-icon"></i>

                <template v-if="topic.user().isAdmin && settings.admin_badge_image !== ''">
                    <img class="admin-badge" :src="settings.admin_badge_image"/>
                </template>
                <template v-else-if="topic.user().isModerator && settings.moderator_badge_image !== ''">
                    <img class="admin-badge" :src="settings.moderator_badge_image"/>
                </template>

                <a :href="'/profile/' + topic.user().username">
                    <p class="profile-name hover-opacity">
                        {{ topic.user().name }}
                        <i v-if="topic.user().birth_date && stripYears(topic.user().birth_date) === stripYears(now)" class="far fa-birthday-cake secondary-c"></i>
                    </p>
                </a>
                <div class="post-karma post-desc-item extra-light-text inline" v-if="topic.user().level && plugins.gamification">
                    Level {{ topic.user().level }}
                </div>
                <div class="post-timestamp post-desc-item extra-light-text inline">
                    <i class="far fa-clock"></i>
                    {{ topicDateAndTime | getDateHumanFormat }}
                </div>
            </template>
            <div v-else class="post-timestamp post-desc-item latest-comment extra-light-text inline">
                <i class="far fa-clock"></i>
                <template v-if="topic.created_at === topic.updated_at">
                    {{ translations['forum.last_comment'] }} {{ topicDateAndTime | getDateHumanFormat }} {{ translations['forum.by'] }} <b class="light-text bold-text">{{ topic.user().name }}</b>
                </template>
                <template v-else>
                    {{ translations['forum.last_comment'] }} {{ topic.updated_at | getDateHumanFormat }} {{ translations['forum.by'] }} <b class="light-text bold-text">{{ topic.last_commenter }}</b>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import moment from 'moment';

    import Global from '../../mixins/Global.js'
    import Feed from '../../mixins/Feed.js'
    import Moment from "../../mixins/Moment.js";
    import Modal from '../../mixins/v2/Modal';
    import Channel from "@/resources/assets/js/vue/lib/models/Channel";

    export default {
        mixins: [Global, Feed, Moment, Modal],

        props: {
            viewType: {
                required: true
            },
            topic: {
                required: true
            },
            singleTopic: {},
            showTopicActions: {
                default: true,
            },
            displayBoard: {
                default: true,
            },
            showUserCredentials: {
                default: true
            },
            showTitle: {
                default: true
            },
        },

        data() {
            return {
                isHelpdesk: isHelpdesk,
            }
        },

        computed: {
            ...mapState([
                'displayMode',
                'plugins'
            ]),

            channel() {
                return Channel.query().where('id', this.topic.board_id).first();
            },

            topicDateAndTime() {
                let created_at = moment(this.topic.created_at);
                let release_date = moment(this.topic.release_date);
                let release_function_released_date = '2018-10-05 13:47:23';

                if(!release_date.isValid() || release_date.isSame(release_function_released_date, 'day') || created_at.isSame(release_date, 'minute')) {
                    return this.topic.created_at;
                } else {
                    return this.topic.release_date;
                }
            },
        },

        methods: {
            lockTopic(payload) {
                let self = this;
                let topic = payload.topic;
                let status = payload.status;
                let setStatusTo = '';
                let closed = 0;

                //if topic is closed, we open it
                if (status === true) {
                    setStatusTo = 'open';
                } else {
                    setStatusTo = 'closed';
                    closed = 1;
                }

                this.$store.dispatch(
                    {
                        type: 'activeDataAction',
                        data: {
                            model: 'Topic',
                            crud_method: 'update',
                            sub_path: '/conversations/update/',
                            save_data: {
                                id: topic.id,
                                status: setStatusTo,
                                closed: closed,
                            },
                            //save_data: {id: topic.id, title: this.modalData.title}
                            //save_data: topic.getDataForSave(),
                            success_callback: function (response) {
                                success_callback(response)
                            }
                        }
                    }
                );

                let success_callback = function (response) {
                    self.$store.commit('updateTopicClosed', {topic: topic, bool: !status});
                }
            },

            stickyTopic(payload) {
                let self = this;
                let topic = payload.topic;
                let commentId = payload.comment_id;
                let sticky = payload.sticky;
                self.$store.commit('toggleSpinner', true);

                this.$store.dispatch(
                    {
                        type: 'activeDataAction',
                        data: {
                            model: 'Topic',
                            crud_method: 'update',
                            sub_path: '/comments/' + commentId,
                            save_data: {
                                'conversation[id]': topic.id,
                                id: commentId,
                                sticky: !sticky,
                            },
                            success_callback: function (response) {
                                success_callback(response)
                            },
                            failure_callback: function (response) {
                                failure_callback(response);
                            }
                        }
                    }
                );

                let success_callback = function (response) {
                    self.$store.commit('updateTopicSticky', {topic: topic, bool: !payload.sticky});
                    self.$store.commit('toggleSpinner', false);
                };

                let failure_callback = function (response) {
                    self.$store.commit('toggleSpinner', false);
                };
            },

            setNotifications(payload) {
                let self = this;
                let topic = payload.topic;
                let notifications = payload.notifications;

                this.$store.dispatch(
                    {
                        type: 'activeDataAction',
                        data: {
                            model: 'Topic',
                            crud_method: 'update',
                            sub_path: '/conversations/' + topic.id,
                            save_data: {
                                notifications: !notifications
                            },
                            success_callback: function (response) {
                                success_callback(response)
                            }
                        }
                    }
                );

                let success_callback = function (response) {
                    self.$store.commit('updateTopicNotifications', {topic: topic, bool: !payload.notifications});
                }
            },

            checkAvailability(topic) {
                if(!topic.permissions.includes('READ')) {
                    let url = '/modals/protected/board/' + topic.board_id;

                    $.get(url, function (result) {
                        var html = result;

                        if (result !== '') {
                            popupBox.setup({
                                viewHtml: html,
                                enterListen: true,
                                enterCount: 0,
                                callbackFunction: function (callback) {
                                    if (callback === 'confirmed') {

                                    }
                                }
                            });
                        } else {
                            alert("Something went wrong. Please contact an administrator if you keep encountering this issue.");
                        }
                    });
                }
            },

            favoriteTopic(payload) {
                let self = this;
                let topic = payload.topic;
                let favorite = payload.favorite;

                this.$store.dispatch(
                    {
                        type: 'activeDataAction',
                        data: {
                            model: 'Topic',
                            crud_method: 'update',
                            sub_path: '/conversations/' + topic.id,
                            save_data: {
                                favorited: !favorite
                            },
                            success_callback: function (response) {
                                success_callback(response)
                            }
                        }
                    }
                );

                let success_callback = function (response) {
                    self.$store.commit('updateTopicFavorite', {topic: topic, bool: !payload.favorite});
                }
            },

            markTopicAsUnread(topic) {
                let self = this;

                this.$store.dispatch(
                    {
                        type: 'activeDataAction',
                        data: {
                            model: 'Topic',
                            crud_method: 'update',
                            sub_path: '/conversations/' + topic.id,
                            save_data: {
                                id: topic.id,
                                read_at: 0
                            },
                            success_callback: function (response) {
                                success_callback(response)
                            }
                        }
                    }
                );

                let success_callback = function (response) {
                    self.$store.commit('setTopicUnread', [topic, true]);
                }
            },
        },
    }
</script>
